import { onBeforeUnmount, onMounted, ref, type Ref } from 'vue';

// Content-box width of an element, kept current with a ResizeObserver; 0 until mounted.
export function useElementWidth(target: Ref<HTMLElement | null>): Ref<number> {
  const width = ref(0);
  let observer: ResizeObserver | null = null;

  onMounted(() => {
    if (!target.value) return;
    width.value = target.value.clientWidth;
    if (typeof ResizeObserver === 'undefined') return;
    observer = new ResizeObserver(([entry]) => {
      if (entry) width.value = entry.contentRect.width;
    });
    observer.observe(target.value);
  });

  onBeforeUnmount(() => observer?.disconnect());

  return width;
}
